import React from 'react';
import { useTranslation } from 'react-i18next';
import { eligibilityOutcomes, formatDatewithNullCheck, hasOverdueService } from '../../../utils/formatting';
import { RouteComponentProps } from 'react-router-dom';
import {getValueOrDefault} from '../../../utils/NullCheck/index'

interface GasBoilerCardProps extends RouteComponentProps<any> {
  GASPropsData:any
}

const GasBoilerServicing: React.FC<GasBoilerCardProps> = ({GASPropsData}) => {
  const { t } = useTranslation();
  return (
    <div className="body-card row m-0 border-terracotta display-column">
        <div className="p-0">
            <div className='flex justify-between pb-16'><h4>{t("GasBoiler")}</h4>
            {hasOverdueService(GASPropsData?.[0]?.nextServiceDueDate) && <h4>{'Overdue'}</h4>}</div>
        </div>
        <div className="mt-2 p-0">
          <div className='record-repair justify-between pb-16'>
            <h5 className='hidden'>{"Due_Date"}</h5><h6>{t("Due_Date")}</h6>
            <p>{formatDatewithNullCheck(GASPropsData?.[0]?.nextServiceDueDate)}</p>
          </div>
          <div className='record-repair justify-between pb-16'>
            <h6>{t("Contractor")}</h6>
            <p>{getValueOrDefault(GASPropsData?.[0]?.contractor?.name)}</p>
          </div>
          <div className='record-repair justify-between pb-16'>
            <h6>{t("Contractor_Contact")}</h6>
            <p>{getValueOrDefault(GASPropsData?.[0]?.contractor?.phoneNumber)}</p>
          </div>
          <div className='record-repair justify-between pb-16'>
            <h6>{t("Last_Visit")}</h6>
            <p>{formatDatewithNullCheck(GASPropsData?.[0]?.lastServiceDueDate)}</p>
          </div>
          <div className='record-repair justify-between pb-16'>
            <h6>{t("Visit_Outcome")}</h6>
            <p>{eligibilityOutcomes(GASPropsData?.[0]?.lastVisitOutcome)}</p>
          </div>
          <div className='record-repair justify-between pb-16'>
            <h6>{t("Date_Decommissioned")}</h6>
            <p>{formatDatewithNullCheck(GASPropsData?.[0]?.applianceEndDate)}</p>
          </div>
        </div>
    </div>
  );
};

export default GasBoilerServicing;